import qs from 'query-string';

export type ComputeRedirectInput = {
  appPath: string; // current app pathname (with trailing slash normalized by caller)
  pageUrl: string; // value returned by page.getUrl()
  CMS_BASE_URL: string;
  SPA_BASE_URL: string;
};

export type ComputeRedirectOutput = {
  shouldRedirect: boolean;
  redirectPath: string;
  redirectQuery: string;
};

export const computeCMSSearchRedirect = ({
  appPath,
  pageUrl,
  CMS_BASE_URL,
  SPA_BASE_URL,
}: ComputeRedirectInput): ComputeRedirectOutput => {
  const base = new URL(CMS_BASE_URL);
  const url = new URL(pageUrl, base); // resolves relative or absolute pageUrl against CMS base
  const resPath = url.pathname;
  const resQuery = url.search;

  const needsSearchRedirect = !appPath.endsWith('search/') && /\/?search\/?$/.test(resPath);

  const PATH_START_PATH = new URL(SPA_BASE_URL, 'http://local').pathname.replace(/\/$/, '');
  const CMS_BASE_PATH = base.pathname;
  const API = '/resourceapi';
  const CMS_API = `${CMS_BASE_PATH === '/' ? '' : CMS_BASE_PATH}${API}`;
  const resAPI = resPath.startsWith(CMS_API) ? CMS_API : API;
  const pathEnd = resPath.startsWith(resAPI) ? resPath.substring(resAPI.length) : resPath;

  // Prefix with SPA base path only once
  const redirectPath = pathEnd.startsWith(PATH_START_PATH)
    ? pathEnd
    : `${PATH_START_PATH}${pathEnd}`;

  const removeBRServerTriggers = (kv: Array<any>) => !String(kv[0]).startsWith('_hn:');
  const filteredResQueryObj = Object.entries(qs.parse(resQuery))
    .filter(removeBRServerTriggers)
    .reduce((acc: any, [prop, value]) => ({ ...acc, [prop]: value }), {} as Record<string, any>);
  const redirectQuery = qs.stringify(filteredResQueryObj);

  return {
    shouldRedirect: needsSearchRedirect,
    redirectPath,
    redirectQuery,
  };
};
